import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../../../Icon';
import PrivacyIcon from '../../../../../PrivacyIcon';
import { formatDate } from '../../../../utils';
import styles from './index.styl';

const RefillCard = ({ entity }) => {
  const [activeCard, setActiveCard] = useState(false);
  const { medications, pharmacyDetails, requestedAt, userName } = entity;
  const { address, pharmacyName, phone } = pharmacyDetails || {};

  const safePharmacy = `${pharmacyName ? `${pharmacyName}, ` : ''}${
    address ? `${address}, ` : ''
  }${phone || ''}`;

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.leftSideWrapper}>
          <Icon size={28} name="docs" className={styles.iconType} />
          <div className={styles.contentWrapper}>
            <div className={styles.title}>{userName}</div>
            <div className={styles.description}>{safePharmacy}</div>
          </div>
        </div>
        <div className={styles.rightBlock}>
          <div className={styles.date}>
            {formatDate(requestedAt, 'h:mm A, MMM D, Y')}
          </div>
          <Icon
            size={16}
            className={styles.icon}
            onClick={() => setActiveCard(!activeCard)}
            name={activeCard ? 'icon-arrow-up' : 'icon-arrow-down'}
          />
        </div>
      </div>
      {activeCard && medications.length > 0 && (
        <div className={styles.activeContent}>
          {medications.map(
            ({
              id,
              name,
              sources,
              isPrivate,
              quantityUnit,
              quantityAmount,
              providerProfile,
            }) => {
              const provider = providerProfile
                ? `${providerProfile.firstName} ${providerProfile.lastName}, `
                : '';
              const source = sources.join(', ');
              return (
                <div className={styles.activeDrugRoot} key={id}>
                  <div className={styles.drugName}>
                    {`${name}${
                      quantityAmount
                        ? `, ${quantityAmount}${quantityUnit || ''}`
                        : ''
                    }`}
                    <PrivacyIcon
                      show={isPrivate}
                      className={styles.privacyIcon}
                    />
                  </div>
                  <div className={styles.description}>{`${provider}${
                    source ? `${source}` : ''
                  }`}</div>
                </div>
              );
            },
          )}
        </div>
      )}
    </div>
  );
};

RefillCard.propTypes = {
  entity: PropTypes.object,
};

export default memo(RefillCard);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/RefillCard/index.jsx